import produce from 'immer'
import { v4 as uuidv4 } from 'uuid'
import { actions } from './actions'

const initialState = {
  bibliotecasFondoFamilia: {
    data: [],
    loading: false,
    error: '',
  },
  bibliotecaFondoFamilia: {
    data: null,
    loading: false,
    error: '',
  },
}

export default function bibFondoFamiliaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.BIBFONDOFAMILIA_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasFondoFamilia: { ...state.bibliotecasFondoFamilia, loading: true },
      }
    case actions.BIBFONDOFAMILIA_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasFondoFamilia: {
          ...state.bibliotecasFondoFamilia,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBFONDOFAMILIA_LOAD_FAILED:
      return {
        ...state,
        bibliotecasFondoFamilia: {
          ...state.bibliotecasFondoFamilia,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBFONDOFAMILIA_LOAD_BY_ID_REQUESTED:
      return {
        ...state,
        bibliotecaFondoFamilia: { ...state.bibliotecaFondoFamilia, data: null, loading: true },
      }
    case actions.BIBFONDOFAMILIA_LOAD_BY_ID_SUCCEEDED:
      return {
        ...state,
        bibliotecaFondoFamilia: {
          ...state.bibliotecaFondoFamilia,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBFONDOFAMILIA_LOAD_BY_ID_FAILED:
      return {
        ...state,
        bibliotecaFondoFamilia: {
          ...state.bibliotecaFondoFamilia,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBFONDOFAMILIA_FILTERED_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasFondoFamilia: { ...state.bibliotecasFondoFamilia, data: null, loading: true },
      }
    case actions.BIBFONDOFAMILIA_FILTERED_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasFondoFamilia: {
          ...state.bibliotecasFondoFamilia,
          data: action.payload,
          loading: false,
        },
      }
    case actions.BIBFONDOFAMILIA_FILTERED_LOAD_FAILED:
      return {
        ...state,
        bibliotecasFondoFamilia: {
          ...state.bibliotecasFondoFamilia,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBFONDOFAMILIA_INSERT_REQUESTED:
      return {
        ...state,
        bibliotecasFondoFamilia: { ...state.bibliotecasFondoFamilia, loading: true },
      }
    case actions.BIBFONDOFAMILIA_INSERT_SUCCEEDED:
      return {
        ...state,
        bibliotecasFondoFamilia: {
          ...state.bibliotecasFondoFamilia,
          data: [...state.bibliotecasFondoFamilia.data, action.payload].sort((a, b) =>
            a.descripcion.localeCompare(b.descripcion),
          ),
          loading: false,
        },
      }
    case actions.BIBFONDOFAMILIA_INSERT_FAILED:
      return {
        ...state,
        bibliotecasFondoFamilia: {
          ...state.bibliotecasFondoFamilia,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBFONDOFAMILIA_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecaFondoFamilia: { ...state.bibliotecaFondoFamilia, loading: true },
        bibliotecasFondoFamilia: { ...state.bibliotecasFondoFamilia, loading: true },
      }
    case actions.BIBFONDOFAMILIA_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecaFondoFamilia: {
          ...state.bibliotecaFondoFamilia,
          data: {
            ...action.payload,
            uuid: uuidv4(),
            files: state.bibliotecaFondoFamilia?.data?.files
              ? [...state.bibliotecaFondoFamilia?.data?.files]
              : [],
          },
          loading: false,
        },
        bibliotecasFondoFamilia: {
          ...state.bibliotecaFondoFamilia,
          data: [
            ...state.bibliotecasFondoFamilia.data?.filter(b => b.id !== action.payload?.id),
            action.payload,
          ].sort((a, b) => a.id - b.id),
          loading: false,
        },
      }

    case actions.BIBFONDOFAMILIA_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaFondoFamilia: {
          ...state.bibliotecaFondoFamilia,
          loading: false,
          error: action.error,
        },
        bibliotecasFondoFamilia: {
          ...state.bibliotecasFondoFamilia,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBFONDOFAMILIA_UPDATE_AREAS_REQUESTED:
      return {
        ...state,
        bibliotecaFondoFamilia: { ...state.bibliotecaFondoFamilia, loading: true },
        bibliotecasFondoFamilia: { ...state.bibliotecasFondoFamilia, loading: true },
      }
    case actions.DELETE_BIBFONDOFAMILIA_REQUESTED:
      return {
        ...state,
        bibliotecasFondoFamilia: { ...state.bibliotecasFondoFamilia, loading: true },
      }
    case actions.DELETE_BIBFONDOFAMILIA_SUCCEEDED: {
      return {
        ...state,
        bibliotecasFondoFamilia: {
          ...state.bibliotecasFondoFamilia,
          data: state.bibliotecasFondoFamilia.data.filter(d => action.payload !== d.id),
          loading: false,
          reload: false,
        },
      }
    }
    case actions.DELETE_BIBFONDOFAMILIA_FAILED:
      return {
        ...state,
        bibliotecasFondoFamilia: {
          ...state.bibliotecasFondoFamilia,
          loading: false,
          error: action.error,
        },
      }

    case actions.UPDATED_FONDO_FAMILIA_FILE: {
      const updatedFondo = action.payload
      const newState = produce(state, draftState => {
        const index = draftState.bibliotecaFondoFamilia?.data?.files?.findIndex(
          p => p.id === updatedFondo.id,
        )
        if (index !== undefined && index !== -1) {
          draftState.bibliotecaFondoFamilia.data.files[index] = updatedFondo
          draftState.bibliotecaFondoFamilia.data.files = draftState.bibliotecaFondoFamilia.data.files.sort(
            (a, b) => a.orden - b.orden,
          )
        }
      })
      return newState
    }

    case actions.DELETED_FONDO_FAMILIA_FILE: {
      const idFondoDeleted = action.payload
      const newState = produce(state, draftState => {
        draftState.bibliotecaFondoFamilia.data.files = draftState.bibliotecaFondoFamilia.data.files.filter(
          p => p.id !== idFondoDeleted,
        )
      })
      return newState
    }

    case actions.INSERTED_FONDO_FAMILIA_FILE: {
      const fondoInserted = action.payload
      const newState = produce(state, draftState => {
        draftState.bibliotecaFondoFamilia.data.files = [
          ...draftState.bibliotecaFondoFamilia.data.files,
          fondoInserted,
        ].sort((a, b) => a.orden - b.orden)
      })
      return newState
    }

    default:
      return state
  }
}
